var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"filter-tag",on:{"click":function($event){return _vm._onclick()}}},[_vm._v(_vm._s(_vm.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }